import styled, { keyframes } from 'styled-components';
import fond_plan_1 from '../assets/image/fond_plan.JPG';
import fond_plan_2 from '../assets/image/fond_plan.JPG';
import fond_plan_3 from '../assets/image/mnb1.JPG';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideBackground = keyframes`
  0% {
    background-image: url(${fond_plan_1});
  }
  33% {
    background-image: url(${fond_plan_2});
  }
  66% {
    background-image: url(${fond_plan_3});
  }
  100% {
    background-image: url(${fond_plan_1});
  }
`;

const HomeSection = styled.section`
  height: 100vh;
  width: 100%;
  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${fond_plan_1});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 50px;
  margin-top: 80px;
  animation: ${slideBackground} 20s infinite;

`;

const Content = styled.div`
  text-align: center;
  color: white;
  max-width: 800px;
  width: 100%;
  animation: ${fadeIn} 1.5s ease-out;
`;

const Title = styled.h1`
  font-size: 48px;
  margin-bottom: 20px;
  opacity: 0;
  animation: ${fadeIn} 1.5s ease-out forwards;
  animation-delay: 0.5s;
  font-weight:600;
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const Description = styled.p`
  font-size: 20px;
  max-width: 600px;
  margin: 0 auto;
  opacity: 0;
  animation: ${fadeIn} 1.5s ease-out forwards;
  animation-delay: 1s;
  font-weight:800;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Home = () => {
  return (
    <HomeSection id="home">
      <Content>
        <Title>New Malamba Business</Title>
        <Description>
          Votre source de confiance pour la Papeterie, les Consommables et Matériels Informatiques.
        </Description>
      </Content>
    </HomeSection>
  );
};

export default Home;
